export default __webpack_public_path__ + "static/sba@2x-911e5dfd8cc06ed7434e8c44145ab56b.png";